import { useCallback, useContext, useMemo, useState } from "react";
import { AuthContext } from "../../../../context/Auth";
import api from "../../../../utils/api";
import { EventosPg } from "../../../../types";

interface GetMembrosProps {

}

export type ResponseMembrosCheckin = {
  listAll: EventosPg[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => Promise<void>
  refecth: VoidFunction
  list: EventosPg[]
  pagina: number,
  getSearchByMinister: (event?: any) => void
  pesquisaPorMinisterio: string
}

const GetEvents = (): ResponseMembrosCheckin => {
  const { token } = useContext(AuthContext);

  const [listCheckinMembros, setListCheckinMembros] = useState<EventosPg[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<EventosPg[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');

  const getSearchByMinister = (event: any) => setPesquisaPorMinisterio(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = async (params: any) => {
    api.get<EventosPg[]>('evento/geral/filtro', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<EventosPg[]>('evento/geral/filtro', { params: { idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [token, resetar]);

  useMemo(() => {
    getList()
  }, [token])


  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams,
    refecth: getList,
    getSearchByMinister,
    pesquisaPorMinisterio
  };
}

export default GetEvents;
